/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
// import moment from 'moment'
import { format } from 'date-fns'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import SelectInput from 'components/Form/components/SelectInput'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./PartnerPlanAdminList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class PartnerPlanUploadLogList extends Component {
  static propTypes = {
    header: PropTypes.string,
    listItems: PropTypes.instanceOf(Array),
  }
  static defaultProps = {
    header: '',
    listItems: [],
  }
  constructor(props) {
    super(props)
    this.state = {
      submit: false,
      recordSelected: '',
    }
  }


  _handleSelectChange = (name, value, selectedIndex) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }
    this.props.getPartnerPlanUploadLogs(value)
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }
  }

  renderCols = () => {
    return (
      <tr>
        <th className={(styles.columns.partner, headerStyles)}>Partner</th>
        <th className={(styles.columns.description, headerStyles)}>Information</th>
        <th className={(styles.columns.timestamp, headerStyles)}>Submitted On</th>
      </tr>
    )
  }

  renderData = () => {
    return this.props.listItems.length ? (
      this.props.listItems.map((item, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className={styles.base} key={`${item.Id}-${i}`}>
          <td className={styles.partner}>
            {item.LoggedUser}
          </td>
          <td>{item.StackTrace}</td>
          <td>{format(new Date(item.TimeStamp), constants.DATE_FORMAT.PARTNER_PLAN_LIST)}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noRecord}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <div className={styles.filter}>
            <SelectInput
              floatedLabel
              handleChange={this._handleSelectChange}
              label="Show data for last"
              layout="halfWidth"
              name="noOfDays"
              onBlur={this._handleValidation}
              options={constants.LIST_FILTERS.NOOFDAYS.options}
              value={this.props.noOfDays}
            />
          </div>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
      </div>
    )
  }
}

export default PartnerPlanUploadLogList



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Admin/PartnerPlanUploadLogList.js